export function hasPrerenderMeta() {
  return (
    typeof document !== 'undefined' &&
    !!document.querySelector('meta[name="prerender-status"][content="ok"]')
  );
}

export function hidePrerenderStaticContent() {
  if (typeof document === 'undefined') return;
  document.body.classList.add('client-article-ready');
}
